import {Chip, IconButton} from '@mui/material';
import styles from './styles.module.scss';
import {ReactComponent as CloseIcon} from '../../../assests/svg/bordered_close_icon.svg';

type AurWorkspaceChipProps<T> = {
  item: T;
  itemKey: keyof T;
  itemLabel: keyof T;
  icon?: React.ReactElement;
  deleteIcon?: React.ReactElement;
  className?: string;
  onClick?: () => void;
  onDelete?: (deletedItem: T) => void;
};

const AurWorkspaceChip = <T,>({
  item,
  itemLabel,
  icon,
  deleteIcon = <CloseIcon />,
  className,
  onClick,
  onDelete,
}: AurWorkspaceChipProps<T>) => {
  const label = item[itemLabel] as unknown as string;

  const aurDeleteIcon = (
    <IconButton
      className={styles.aurDeleteButtonIcon}
      aria-label={`Delete ${label}`}
      data-testid={`${label}-delete-icon`}
    >
      {deleteIcon}
    </IconButton>
  );

  return (
    <Chip
      className={`${styles.AurBasicChip} ${className}`}
      label={label}
      icon={icon}
      deleteIcon={aurDeleteIcon}
      onClick={onClick}
      onDelete={onDelete ? () => onDelete(item) : undefined}
      data-testid={`${label}-delete`}
    />
  );
};

export default AurWorkspaceChip;
